export const chartFonts = {
  family: 'karla-regular, ui-sans-serif, system-ui, Arial',
};
